import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  actions: hasMany('action', { inverse: null }),
  articles: hasMany('article', { inverse: null }),
  artistTypes: hasMany('artist', { inverse: null }),
  artists: hasMany('artist', { inverse: null }),
  assets: hasMany('asset', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  labels: hasMany('label', { inverse: null }),
  liveEvents: hasMany('live-event', { inverse: null }),
  mediaEmbeds: hasMany('media-embed', { inverse: null }),
  mediaEvents: hasMany('media-event', { inverse: null }),
  productFamilies: hasMany('product-family', { inverse: null }),
  products: hasMany('product', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  stories: hasMany('story', { inverse: null }),
  teasers: hasMany('teaser', { inverse: null }),
  webSeries: hasMany('web-series', { inverse: null }),
});
